// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

class LocalisableError extends Error {
  constructor(message, lnKey, ...lnVars) {
    super(message)
    this.message = message
    this.lnKey = lnKey
    this.lnVars = lnVars
  }
}

class InvalidRequest extends LocalisableError {}
class NotAuthenticated extends LocalisableError {}
class NotAuthorised extends LocalisableError {}
class NotificationError extends LocalisableError {}

class NotFound extends LocalisableError {
  constructor() {
    super(...arguments)
    this.name = 'ResourceNotFoundError'
    Error.captureStackTrace(this, this.constructor)
  }
}

export {
  InvalidRequest,
  NotAuthenticated,
  NotAuthorised,
  NotificationError,
  NotFound,
}
